"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  margin-bottom: 1em;\n  color: #4a4a4a;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileDescriptionContainer = void 0;

var _core = require("@emotion/core");

var fileDescriptionContainer = function fileDescriptionContainer(_ref) {
  var _ref$warn = _ref.warn,
      warn = _ref$warn === void 0 ? false : _ref$warn;
  return (0, _core.css)(_templateObject(), warn && 'color: #bbbbbb;');
};

exports.fileDescriptionContainer = fileDescriptionContainer;